import { I18nContext } from 'contexts/I18n/I18nProvider'
import CardComponent from 'core/card'
import { CardPaddings } from 'core/card/enum'
import NoRecords from 'core/no-records/no-records-container'
import React, { useContext } from 'react'
import { MappedWifiEvents } from '../../redux/types'
import Graphic from './Graphic'

type BandwidthAndChannelProps = {
  events: MappedWifiEvents
}

export default function BandwidthAndChannel({ events }: BandwidthAndChannelProps) {
  const t = useContext(I18nContext)

  return (
    <div className="tile is-parent is-vertical has-padding-sm">
      <div className="tile is-child">
        <CardComponent isFullHeight padding={CardPaddings.MEDIUM}>
          <div>
            <h2 className='subtitle'>{t('wifi_dashboards.bandwidth_channel_number')}</h2>
          </div>
          <div className="wifi-divider" />
          {Object.keys(events).length ? <Graphic events={events} /> : <NoRecords style={{ height: 'auto' }} />}
        </CardComponent>
      </div>
    </div>
  )
}
